<template>
  <div class="video-contaienr" :style="videoContainStyl">
    <!-- <video
      class="video-box"
      :style="videoStyl"
      :src="receiveProps.tempData.specialData.bannerVideoUrl"
      autoplay
      muted
      loop
    ></video> -->
    <VideoBox
    class="video-box"
    :style="videoStyl"
    :videoUrl="receiveProps.tempData.specialData.bannerVideoUrl"
    v-if="receiveProps.tempData.specialData.bannerVideoUrl"
    />
    <img
      class="video-img"
      src="http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635498277038.png" alt="" v-else>
  </div>
</template>

<script>
export default {
  name: "videoBanner",
  props: {
    receiveProps: {
      type: [Object, Array],
      default: () => {},
    },
  },
  mounted(){
    this.getImageInfoList(this.receiveProps.tempData.specialData)
  },
  components:{
    VideoBox: ()=>import('./components/VideoBannerCom')
  },
  computed: {
    videoContainStyl(){
      let {blockMargeTop, blockMargeBottom, imgBackgroundColor} = this.receiveProps.tempData.specialStyle    
      let { bannerWrap } = this.receiveProps.tempData.specialData;
      return {
        width: bannerWrap == 1 ? "1200px" : "100%",
        height: bannerWrap == 1 ? "650px" : "800px",
        marginTop: `${blockMargeTop}px`,
        marginBottom: `${blockMargeBottom}px`,
        backgroundColor: imgBackgroundColor
      };  
    },
    videoStyl() {
      let { bannerWrap } = this.receiveProps.tempData.specialData;
      return {
        width: bannerWrap == 1 ? "1200px" : "100%",
        height: bannerWrap == 1 ? "650px" : "800px",
      };
    },
  },
  methods: {
    getImageInfoList(articleDataList){
      let idList = articleDataList.fileId
      this.$apipcs.news.getImageList([idList]).then(res=>{
      let ImageInfoList = res.data
      ImageInfoList[0]&&(articleDataList.videoUrl = ImageInfoList[0].url)
      
    })
    }
  }
};
</script>

<style lang="less" scoped>
.video-contaienr {
  margin: 10px auto 0;
  display: flex;
  justify-content: center;
  .video-box {
    object-fit: fill;
  }
}
.video-img {
  width: 1200px;
}
</style>
